/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('XInput', {
    staticClass: "scan-com",
    attrs: {
      "show-clear": false,
      "placeholder": _vm.placeholder,
      "text-align": "right"
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticClass: "cell-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e()]), _vm.inDingding ? _c('div', {
    staticClass: "cell-child",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.scan
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "icon-i",
    attrs: {
      "src": "/spa_static_mobile/icon/code24_23@3x.png"
    }
  })])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };